<template>
  <div class="employee-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">员工管理</span>
      </div>
      <el-button type="primary" @click="openAddDialog">
        <i class="el-icon-plus"></i> 新增员工
      </el-button>
    </div>

    <div class="search-bar">
      <el-input placeholder="搜索用户名/姓名" v-model="searchForm.keyword" style="width: 220px;" clearable @keyup.enter.native="handleSearch">
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
      <el-select placeholder="角色筛选" v-model="searchForm.roleFilter" style="width: 120px; margin-left: 10px;" clearable>
        <el-option label="全部角色" value=""></el-option>
        <el-option label="管理员" value="ADMIN"></el-option>
        <el-option label="高管" value="EXECUTIVE"></el-option>
        <el-option label="内勤" value="STAFF"></el-option>
        <el-option label="教练" value="COACH"></el-option>
        <el-option label="司机" value="DRIVER"></el-option>
        <el-option label="业务员" value="SALES"></el-option>
        <el-option label="财务" value="FINANCE"></el-option>
        <el-option label="人事" value="HR"></el-option>
      </el-select>
      <el-select placeholder="审核状态" v-model="searchForm.auditFilter" style="width: 120px; margin-left: 10px;" clearable>
        <el-option label="全部" :value="''"></el-option>
        <el-option label="待审核" :value="0"></el-option>
        <el-option label="已通过" :value="1"></el-option>
        <el-option label="已拒绝" :value="2"></el-option>
      </el-select>
      <el-select placeholder="封禁状态" v-model="searchForm.statusFilter" style="width: 120px; margin-left: 10px;" clearable>
        <el-option label="全部" value=""></el-option>
        <el-option label="正常" value="normal"></el-option>
        <el-option label="已封禁" value="banned"></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">
        <i class="el-icon-search"></i> 查询
      </el-button>
      <el-button @click="handleReset" style="margin-left: 10px;">
        <i class="el-icon-refresh"></i> 重置
      </el-button>
    </div>

    <el-card class="table-card">
      <el-table :data="employees" v-loading="loading" stripe border style="width: 100%;">
        <el-table-column prop="userName" label="用户名" width="160"></el-table-column>
        <el-table-column prop="nickName" label="姓名" width="120"></el-table-column>
        <el-table-column prop="roleName" label="角色" width="100"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.auditStatus === 0" style="color: #e6a23c;">待审核</span>
            <span v-else-if="scope.row.auditStatus === 1" style="color: #67c23a;">已通过</span>
            <span v-else-if="scope.row.auditStatus === 2" style="color: #f56c6c;">已拒绝</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="封禁状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.isBanned" style="color: #f56c6c;">已封禁</span>
            <span v-else style="color: #67c23a;">正常</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="lastLoginTime" label="最后登录" width="180"></el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="openResetPwdDialog(scope.row)">重置密码</el-button>
            <el-button type="text" size="small" @click="handleApprove(scope.row)" v-if="scope.row.auditStatus === 0">通过</el-button>
            <el-button type="text" size="small" @click="handleReject(scope.row)" v-if="scope.row.auditStatus === 0">拒绝</el-button>
            <el-button type="text" size="small" class="warning" @click="handleBan(scope.row)" v-if="!scope.row.isBanned">封禁</el-button>
            <el-button type="text" size="small" class="success" @click="handleUnban(scope.row)" v-else>解封</el-button>
            <el-button type="text" size="small" class="danger" @click="deleteEmployee(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-sizes="[20, 50, 100]"
          :page-size="pagination.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入用户名（可填写手机号）"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="form.nickName" placeholder="请输入员工姓名"></el-input>
        </el-form-item>
        <el-form-item v-if="!isEdit" label="登录密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="userRole">
          <el-select v-model="form.userRole" placeholder="请选择角色" style="width: 100%;">
            <el-option label="管理员" value="ADMIN"></el-option>
            <el-option label="高管" value="EXECUTIVE"></el-option>
            <el-option label="内勤" value="STAFF"></el-option>
            <el-option label="教练" value="COACH"></el-option>
            <el-option label="司机" value="DRIVER"></el-option>
            <el-option label="业务员" value="SALES"></el-option>
            <el-option label="财务" value="FINANCE"></el-option>
            <el-option label="人事" value="HR"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" prop="auditStatus">
          <el-radio-group v-model="form.auditStatus">
            <el-radio :label="0">待审核</el-radio>
            <el-radio :label="1">已通过</el-radio>
            <el-radio :label="2">已拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封禁">
          <el-switch v-model="form.isBanned"></el-switch>
          <span v-if="form.isBanned" style="margin-left: 10px; color: #f56c6c;">（已封禁）</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEmployee">确定</el-button>
      </span>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog title="重置密码" :visible.sync="resetPwdDialogVisible" width="450px">
      <el-form :model="resetPwdForm" :rules="resetPwdRules" ref="resetPwdForm" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="resetPwdForm.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="resetPwdForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="resetPwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmResetPwd">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getEmployeeList, getRoleList, addEmployee, updateEmployee, deleteEmployee, resetEmployeePassword } from '@/api/employeeApi'

export default {
  name: 'EmployeeManage',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (this.isEdit && !value) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请输入登录密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6位'))
      } else {
        callback()
      }
    }
    return {
      searchForm: {
        keyword: '',
        roleFilter: '',
        auditFilter: '',
        statusFilter: ''
      },
      dialogVisible: false,
      dialogTitle: '新增员工',
      isEdit: false,
      form: {
        userId: null,
        userName: '',
        nickName: '',
        password: '',
        userRole: '',
        auditStatus: 0,
        isBanned: false
      },
      rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入员工姓名', trigger: 'blur' }],
        password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        userRole: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      employees: [],
      roleOptions: [],
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      loading: false,
      resetPwdDialogVisible: false,
      resetPwdForm: {
        userId: null,
        userName: '',
        newPassword: ''
      },
      resetPwdRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadEmployees()
    this.loadRoles()
  },
  methods: {
    async loadEmployees() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getEmployeeList(params)
        if (res) {
          this.employees = res.list || []
          this.total = res.total || 0
        } else {
          this.employees = []
          this.total = 0
        }
      } catch (e) {
        console.error('加载员工列表失败', e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadEmployees()
    },
    handleReset() {
      this.searchForm = {
        keyword: '',
        roleFilter: '',
        auditFilter: '',
        statusFilter: ''
      }
      this.pagination.page = 1
      this.loadEmployees()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadEmployees()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadEmployees()
    },
    async loadRoles() {
      try {
        const res = await getRoleList()
        this.roleOptions = res || []
      } catch (e) {
        console.error('加载角色列表失败', e)
      }
    },
    goBack() {
      this.$router.push('/home/workbench')
    },
    getRoleTagType(role) {
      const map = {
        'ADMIN': 'danger',
        'EXECUTIVE': 'warning',
        'STAFF': 'info',
        'COACH': 'success',
        'DRIVER': '',
        'SALES': 'primary',
        'FINANCE': 'warning',
        'HR': 'info'
      }
      return map[role] || 'info'
    },
    openAddDialog() {
      this.isEdit = false
      this.dialogTitle = '新增员工'
      this.form = {
        userId: null,
        userName: '',
        nickName: '',
        password: '',
        userRole: '',
        auditStatus: 0,
        isBanned: false
      }
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.isEdit = true
      this.dialogTitle = '编辑员工'
      this.form = {
        userId: row.userId,
        userName: row.userName,
        nickName: row.nickName,
        password: '',
        userRole: row.userRole,
        auditStatus: row.auditStatus || 0,
        isBanned: row.isBanned || false
      }
      this.dialogVisible = true
    },
    async saveEmployee() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isEdit) {
              await updateEmployee(this.form)
              this.$message.success('修改成功')
            } else {
              await addEmployee(this.form)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadEmployees()
          } catch (e) {
            this.$message.error(e.message || '操作失败')
          }
        }
      })
    },
    async handleApprove(row) {
      try {
        await this.$confirm(`确定通过用户"${row.userName}"的审核吗？`, '审核确认', { type: 'info' })
        await updateEmployee({ userId: row.userId, auditStatus: 1 })
        this.$message.success('审核已通过')
        this.loadEmployees()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleReject(row) {
      try {
        await this.$confirm(`确定拒绝用户"${row.userName}"的审核吗？`, '审核确认', { type: 'warning' })
        await updateEmployee({ userId: row.userId, auditStatus: 2 })
        this.$message.success('审核已拒绝')
        this.loadEmployees()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleBan(row) {
      try {
        await this.$confirm(`确定封禁用户"${row.userName}"吗？`, '提示', { type: 'warning' })
        await updateEmployee({ userId: row.userId, isBanned: true })
        this.$message.success('已封禁该用户')
        this.loadEmployees()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleUnban(row) {
      try {
        await this.$confirm(`确定解除用户"${row.userName}"的封禁状态吗？`, '提示', { type: 'info' })
        await updateEmployee({ userId: row.userId, isBanned: false })
        this.$message.success('已解除封禁')
        this.loadEmployees()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async deleteEmployee(row) {
      try {
        await this.$confirm('确定删除该员工？删除后将无法恢复。', '警告', { type: 'warning' })
        await deleteEmployee(row.userId)
        this.employees = this.employees.filter(e => e.userId !== row.userId)
        this.$message.success('删除成功')
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    },
    openResetPwdDialog(row) {
      this.resetPwdForm = {
        userId: row.userId,
        userName: row.userName,
        newPassword: ''
      }
      this.resetPwdDialogVisible = true
    },
    async confirmResetPwd() {
      this.$refs.resetPwdForm.validate(async valid => {
        if (valid) {
          try {
            await resetEmployeePassword({
              userId: this.resetPwdForm.userId,
              newPassword: this.resetPwdForm.newPassword
            })
            this.$message.success('密码重置成功')
            this.resetPwdDialogVisible = false
          } catch (e) {
            this.$message.error(e.message || '密码重置失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.employee-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left i {
  font-size: 20px;
  cursor: pointer;
  margin-right: 12px;
  color: #409eff;
}

.header-left i:hover {
  color: #66b1ff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.search-bar {
  display: flex;
  align-items: center;
  margin: 15px 20px;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}

.danger {
  color: #f56c6c;
}

.danger:hover {
  color: #f78989;
}

.warning {
  color: #e6a23c;
}

.warning:hover {
  color: #ebb563;
}

.success {
  color: #67c23a;
}

.success:hover {
  color: #85ce61;
}

.table-card {
  margin: 0 20px;
  border-radius: 8px;
  background: #fff;
  padding: 15px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
</style>
